export const createCreditCardsRepository = (appFetch) => {
    return {
        list(options = {}) {
            return appFetch.get('/api/v1/personal/credit-cards/products', options);
        },
        details(slug, options = {}) {
            return appFetch.get(`/api/v1/personal/credit-cards/products/${slug}`, options);
        },
        filters(options = {}) {
            return appFetch.get('/api/v1/personal/credit-cards/filters', options);
        },
        advantagesTypes(options = {}) {
            return appFetch.get('/api/v1/personal/credit-cards/advantage-types', options);
        },
        paymentSystems(options = {}) {
            return appFetch.get('/api/v1/personal/credit-cards/payment-systems', options);
        },
    };
};
